$('.each').each(function() {
	var handle = $(this).attr('data-product');
	var alt = $(this).attr('data-alt');
	var url = '/products/' + handle + '.js';
	var count = 0;
	jQuery.getJSON(url, function(product) {
		$.each( product.images, function( key, value ) {
			count++;
			if (~value.indexOf(alt)) {
			  $('.'+alt).attr('src',value);
			}
		});
	});
});
